import React from 'react';

import AuthenticationLayout from '@/components/layout/AuthenticationLayout.tsx';
import LoginForm from '@/components/layout/loginPage/LoginForm.tsx';

const SignIn: React.FC = () => {
  return (
    <AuthenticationLayout>
      <LoginForm />
    </AuthenticationLayout>
  );
};

export default SignIn;
